import Cookies from 'js-cookie';
import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import DetailHome from '../pages/detail-home/DetailHome';
import DashboardLayout from '../layout/dashboard/DashboardLayout';
import LandingLayout from '../layout/landing/LandingLayout';
import Dashboard from '../pages/dashboard/dashboard';
import Home from '../pages/home/Home';
import ListDashboard from '../pages/list-data-dashboard/ListDashboard';
import Login from '../pages/login/login';
import Register from '../pages/register/Register';
import JobVacancyCreate from '../pages/job-vacancy-create/JobVacancyCreate';
import JobVacancyEdit from '../pages/job-vacancy-edit/JobVacancyEdit';

const Routes = () => {
  const LoginRoute = ({ ...props }) => {
    if (Cookies.get('token') !== undefined) {
      return <Redirect to={'/dashboard'} />;
    } else if (Cookies.get('token') === undefined) {
      return <Route {...props} />;
    }
  };

  const DashboardRoute = ({ ...props }) => {
    if (Cookies.get('token') !== undefined) {
      return <Route {...props} />;
    } else if (Cookies.get('token') === undefined) {
      return <Redirect to={'/login'} />;
    }
  };

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path={'/'} exact>
            <LandingLayout>
              <Home />
            </LandingLayout>
          </Route>
          <Route path={'/job-vacancy/:slug'} exact>
            <LandingLayout>
              <DetailHome />
            </LandingLayout>
          </Route>
          <LoginRoute path={'/login'} exact>
            <Login />
          </LoginRoute>
          <DashboardRoute path={'/dashboard'} exact>
            <DashboardLayout>
              <Dashboard />
            </DashboardLayout>
          </DashboardRoute>
          <DashboardRoute path={'/dashboard/list-job-vacancy'} exact>
            <DashboardLayout>
              <ListDashboard />
            </DashboardLayout>
          </DashboardRoute>
          <Route path={'/register'} exact>
            <Register />
          </Route>
          <Route path={'/dashboard/list-job-vacancy/form/create'} exact>
            <DashboardLayout>
              <JobVacancyCreate />
            </DashboardLayout>
          </Route>
          <Route path={'/dashboard/list-job-vacancy/form/edit/:slug'} exact>
            <DashboardLayout>
              <JobVacancyEdit />
            </DashboardLayout>
          </Route>
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default Routes;
